const fonts = {
    primary:"'Roboto', sans-serif",
    secondary:"'Barlow', sans-serif"
};

export default fonts;